import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AuthStateService } from './core/data-access/services/auth-state.service';
import { filter } from 'rxjs/operators';
import { secureStorage } from './core/data-access/services/localstorage.service';
import { esCuentaSinRestriccion } from './core/data-access/services/permisosv1.service';
import { ModalService } from './shared/data-access/services/modal.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  styleUrls: ['./app.component.css'],
  template: ` <router-outlet /> `
})
export class AppComponent implements OnInit {
  idUser!: string
  email!: string
  constructor(
    private readonly srvAuth: AuthStateService,
    private readonly router: Router,
    private readonly srvModal: ModalService
  ) {
  }

  // @HostListener('window:popstate', ['$event'])
  // onPopState(event: PopStateEvent) {
  //   if (Swal.isVisible()) {
  //     Swal.close();
  //   }
  //   this.srvModal.closeModal();
  // }

  ngOnInit(): void {

    const data = secureStorage.getItem('userData');
    const user = data ? data : null;
    if (user) {
      this.idUser = user.sistema_id
      this.email = user.usuario.str_usuario_email

      const currentPath = window.location.pathname;
      const privateRoutes = ['/dashboard', '/empresas', '/ajustes', '/documentos', '/recursos'];
      const isPrivateRoute = privateRoutes.some(route => currentPath.startsWith(route));

      if (!esCuentaSinRestriccion(this.email) && isPrivateRoute) {
        this.srvAuth.obtenerPermisosUsuarioLogueado(+this.idUser, false);
      }
    }

  }

}

